import { FlightInformationController } from './flight-information-controller';
import { FlightsSearchController } from './flights-search-controller';

export const controllers = [FlightInformationController, FlightsSearchController];
